//produccion
const base="https://ordenes.farmex.cl/serviciosfarmex/"

//desarrollo
//const base="https://localhost:44360/"

export const Paginas=
{
    calculadoraDespacho:base+"DespachoCalculadora/Valor/@id",
    comuna:base+"DespachoCalculadora/Dato/@id"
}